export default function formatStrDate(strDate) {
  const split = strDate.substr(0, 10).split('-')
  if (split.length !== 3) {
    return ''
  }
  const d = parseInt(split[2])
  const m = parseInt(split[1])
  const y = split[0]
  return m + '/' + d + '/' + y
}
